// extracted by mini-css-extract-plugin
export default {"titleAnimation":"header_titleAnimation__HUggY","reverseTitleAnimation":"header_reverseTitleAnimation__2clf5"};